import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=7bcee918&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=7bcee918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcee918",
  null
  
)

export default component.exports